<template>
  <div>
    <transition name="fadedown">
      <div class="confirmbox_warp" v-if="isShow">
        <div class="confirm_box">
          <div class="box_title">
            <span>{{content.title}}</span>
            <span><i class="el-icon-close" @click="isShow = false"></i></span>
          </div>
          <div class="box_body">
            <i class="el-icon-warning"></i>
            <!-- {{content.text}} -->
            <span v-html="content.text"></span>
          </div>
          <div class="box_footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="ok">确认</el-button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShow: false,
      content: {
        title: '',
        text: ''
      },
      ms: ''
    }
  },
  mounted() {
    this.isShow = true
  },
  methods: {
    ok() {

    },
    close() {

    }
  },
}
</script>

<style lang="scss" scoped>
.fadedown-enter-active {
  animation: downTrans 0.2s;
}
.fadedown-leave-active {
  animation: downTrans 0.2s reverse;
}
@keyframes downTrans {
  0% {
    top: -10px;
    opacity: 0;
  }
  100% {
    top: 0;
    opacity: 1;
  }
}

.confirmbox_warp {
  position: fixed;
  z-index: 1000000;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);

  .confirm_box {
    position: absolute;
    width: 550px;
    top: 15vh;
    left: 50%;
    transform: translateX(-50%);
    background-color: #fff;
    border-radius: 5px;
    overflow: hidden;
    .box_title {
      padding: 18px 20px;
      background-color: #f1f1f5;
      display: flex;
      justify-content: space-between;
      font-size: 18px;
      i {
        cursor: pointer;
      }
    }
    .box_body {
      padding: 25px 20px;
      display: flex;
      align-items: center;
      i {
        font-size: 26px;
        color: #e6a23c;
        margin-right: 10px;
      }
    }
    .box_footer {
      padding: 10px 20px;
      display: flex;
      justify-content: flex-end;
      border-top: 1px solid #f1f1f5;
    }
  }
}
</style>
